var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneSvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    id: "phone",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "path-1",
    d: "M.06 64V.04H64V64z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "phone"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    fill: "#76ABC4",
    d: "M64 32c0 17.673-14.327 32-32 32C14.327 64 0 49.673 0 32 0 14.327 14.327 0 32 0c17.673 0 32 14.327 32 32",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Fill-4",
    fill: "#638DA0",
    d: "M43.17 50a1.04 1.04 0 0 1-.336-.052c-.228-.075-.526-.155-.889-.256-4.704-1.302-19.016-5.263-25.903-26.629a1.081 1.081 0 0 1-.021-.589c.035-.14.903-3.5 6.677-4.458a1.064 1.064 0 0 1 .635.085c.211.096 5.212 2.448 5.629 7.242.029.306-.076.611-.283.836-1.639 1.776-3.064 3.96-2.988 4.582.131 1.106 3.603 6.939 9.82 9.979.927-.147 3.076-1.563 4.632-2.892a1.08 1.08 0 0 1 .7-.263c.088 0 .177.011.264.034 4.932 1.196 6.71 4.58 6.784 4.724.105.205.142.441.105.668-.831 5.224-4.231 6.825-4.375 6.891a1.087 1.087 0 0 1-.451.098"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-5",
    fill: "#FFFFFE",
    d: "M28.962 23.343c-.417-4.794-5.418-7.146-5.629-7.242a1.063 1.063 0 0 0-.635-.085c-5.774.958-6.642 4.318-6.677 4.458-.048.196-.04.399.021.589 6.887 21.366 21.199 25.327 25.903 26.629.363.101.661.181.889.256a1.087 1.087 0 0 0 .787-.046c.144-.066 3.544-1.667 4.375-6.891.037-.227 0-.463-.105-.668-.074-.144-1.852-3.528-6.784-4.724a1.066 1.066 0 0 0-.964.229c-1.556 1.329-3.705 2.745-4.632 2.891-6.217-3.039-9.689-8.872-9.82-9.978-.076-.622 1.349-2.806 2.988-4.582.207-.225.312-.53.283-.836"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneSvgIcon);
export default __webpack_public_path__ + "static/media/phone-svg-icon.24b2e36789580ffbc2a222f56fec938e.svg";
export { ForwardRef as ReactComponent };